import { render, staticRenderFns } from "./ApplicantFormValiev.vue?vue&type=template&id=522dadbc&scoped=true&"
import script from "./ApplicantFormValiev.vue?vue&type=script&lang=js&"
export * from "./ApplicantFormValiev.vue?vue&type=script&lang=js&"
import style0 from "./ApplicantFormValiev.vue?vue&type=style&index=0&id=522dadbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522dadbc",
  null
  
)

export default component.exports